<template>
  <div>
    <v-card :to="to" class="py-5 d-flex align-center schedule-item" flat tile>
      <div
        class="
          text-body-2
          primary--text
          d-flex
          flex-column
          justify-center
          align-center
          text-center
        "
      >
        <div class="text-h5 font-weight-bold">
          {{ date[0] }}
        </div>
        <div class="text-body-2 text-uppercase">
          {{ date[1] }}
        </div>
      </div>
      <v-divider class="mx-3" vertical></v-divider>
      <div>
        <div
          class="
            font-weight-bold
            text-body-2 text--darken-4
            mb-2
            grey--text
            schedule-item-title
          "
        >
          {{ title }}
        </div>
        <div class="text-body-2 font-weight-medium">{{ local }}</div>
      </div>
    </v-card>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    date: {
      type: Array,
      required: true,
    },
    local: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.schedule-item-title {
  transition: all 0.1s linear;
}
.schedule-item:hover .schedule-item-title {
  color: var(--v-primary-base) !important;
}
</style>
